import './style.scss';
import $ from 'jquery';
import { gsap } from 'gsap';
import { ScrollTrigger } from "gsap/ScrollTrigger.js";

gsap.registerPlugin(ScrollTrigger);

function revealFunction() {
	if($(".wp-block-krutablocks-clients__container.anim-reveal").length) {

		ScrollTrigger.batch(".wp-block-krutablocks-client", {
		  onEnter: batch => {
		    batch.forEach((section, i) => {
		      gsap.fromTo(section, {autoAlpha:0,y:40}, {
		      	autoAlpha: 1,
		      	y: 0,
		        duration: 0.6,
		        stagger: 0.1,
		        delay: i * 0.3,
		      });
		    });
		  },
  		  once: true,
		  start: "+=100 bottom"
		});
	}
}

$(window).on('load', () => {
  if($('.c-loader').length) {
    setTimeout(() => { 
          revealFunction();
      }, 3200);
  } else {
    setTimeout(() => { 
          revealFunction();
      }, 400);
  }
})